export default __webpack_public_path__ + "static/media/separating.3b26c076.jpg";